/**
 * Cost / access copy for the homepage "Start free" band and the hero derisk row.
 *
 * Mirrored verbatim from the shipped AI Fluens Studio landing page
 * (LabsPlanMyCareer/apps/web/src/pages/landing/landing-content.ts → COST_TILES /
 * DERISK_POINTS) so the claims here match the real product. The two apps are
 * separate packages, so this is a deliberate copy — keep it in sync if the
 * Studio pricing copy changes.
 */

/** Short reassurance chips shown under the hero CTA. */
export const DERISK_POINTS: readonly string[] = [
  '$2 free credits',
  'No credit card',
  'Bring your own key',
] as const;

export type CostTile = {
  /** Large headline value, e.g. "$2" / "BYOK" / "$0". */
  readonly big: string;
  readonly title: string;
  readonly detail: string;
};

export const COST_TILES: readonly CostTile[] = [
  {
    big: '$2',
    title: 'Free credits on signup',
    detail: 'Enough to build one real agent. No credit card required.',
  },
  {
    big: 'BYOK',
    title: 'Bring your own key',
    detail: 'Anthropic, OpenAI, Google, Bedrock, Azure or Vertex — your usage, your provider.',
  },
  {
    big: '$0',
    title: 'To browse everything',
    detail: 'The full 36-lesson curriculum is open before you ever sign up.',
  },
] as const;
